import type { TypedDocumentNode } from '@apollo/client';
import { gql, useLazyQuery } from '@apollo/client';

import type { Sport } from '__generated__/globalTypes';
import type { FormRenderProps } from 'components/form/Form';
import { GraphqlForm } from 'components/form/Form';
import { useWalletContext } from 'contexts/wallet';
import { useEvents } from 'lib/events/useEvents';

import type {
  CheckManagernameAvailability,
  CheckManagernameAvailabilityVariables,
} from './__generated__/index.graphql';

const CHECK_MANAGERNAME_AVAILABILITY_QUERY = gql`
  query CheckManagernameAvailability($nickname: String!) {
    isNicknameAvailable(nickname: $nickname)
  }
` as TypedDocumentNode<
  CheckManagernameAvailability,
  CheckManagernameAvailabilityVariables
>;

type NicknameProps = {
  sport: Sport;
  onSuccess: ({ nickname }: { nickname?: string }) => void;
  onError: () => void;
  render: FormRenderProps;
};

export const NicknameForm = ({
  sport,
  onSuccess,
  onError,
  render,
}: NicknameProps) => {
  const { signUp } = useWalletContext();
  const [search] = useLazyQuery(CHECK_MANAGERNAME_AVAILABILITY_QUERY);
  const track = useEvents();

  return (
    <GraphqlForm<{ nickname?: string }>
      onSubmit={async ({ nickname }, onResult, onCancel) => {
        const { data } = await search({ variables: { nickname } });

        if (data?.isNicknameAvailable) {
          signUp(nickname, sport);
          onResult({ nickname });
          track('Choose Signup Manager Name', {});
        } else {
          track('Fail Signup Manager Name', {});
          onResult({
            error: 'Username is already taken',
          });
          onCancel();
        }
      }}
      onSuccess={onSuccess}
      onError={onError}
      render={render}
    />
  );
};
